import SalesOrderSheetListContainer from '../../containers/sales_order_sheet/SalesOrderSheetListContainer';

const SalesOrderSheetPage = () => {
  return <SalesOrderSheetListContainer />;
};

export default SalesOrderSheetPage;
